"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const moment_1 = __importDefault(require("moment"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = __importStar(require("react"));
const calendar_1 = require("@kyruus/calendar");
const read_only_1 = __importDefault(require("../../read-only"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
const styles_1 = require("../../../styles");
const StyleWrapper = styled_1.default.div `
  input {
    height: 32px; /* 34px (standard field height) - 2px border */
  }
`;
const DateInput = ({ path }) => {
    const [state, actions] = (0, use_form_1.default)(path, {
        eventProcessor: (date) => (date ? date.format('YYYY-MM-DD') : '')
    });
    const [focus, setFocus] = (0, react_1.useState)(false);
    if (!state.config.isVisible)
        return null;
    if (state.config.isReadOnly)
        return react_1.default.createElement(read_only_1.default, { msg: state.value });
    const isOutsideRange = (date) => {
        let outsideRange = false;
        if (state.config.endLimit &&
            date.isAfter((0, moment_1.default)(state.config.endLimit).endOf('day'))) {
            outsideRange = true;
        }
        if (state.config.startLimit &&
            date.isBefore((0, moment_1.default)(state.config.startLimit).startOf('day'))) {
            outsideRange = true;
        }
        if (date.isBefore((0, moment_1.default)('1901-01-01').startOf('day')) ||
            date.isAfter((0, moment_1.default)('2099-12-31').startOf('day'))) {
            outsideRange = true;
        }
        return outsideRange;
    };
    const errorMessages = state.errors.map((error) => (react_1.default.createElement(styles_1.ErrorMessage, { key: error }, error)));
    const getSize = () => {
        switch (state.config.width) {
            case 's':
                return { small: true };
            case 'm':
                return { medium: true };
            case 'l':
                return { block: true };
            default:
                return null;
        }
    };
    return (react_1.default.createElement(styles_1.FieldErrorWrapper, { errors: state.errors },
        react_1.default.createElement(StyleWrapper, null,
            react_1.default.createElement(calendar_1.SingleDatePicker, Object.assign({ id: path, required: state.config.isRequired, numberOfMonths: 1, readOnly: !state.config.allowKeyboardInput, disabled: state.config.isReadOnly, date: state.value ? (0, moment_1.default)(state.value) : undefined, focused: focus, showClearDate: true, placeholder: state.config.placeholder, onDateChange: actions.onChange, onFocusChange: ({ focused }) => {
                    setFocus(focused);
                }, onClose: ({ date }) => actions.onBlur(date), isOutsideRange: isOutsideRange }, getSize())),
            errorMessages.length > 0 && errorMessages)));
};
DateInput.propTypes = {
    path: prop_types_1.default.string.isRequired
};
exports.default = DateInput;
exports.defaultConfig = { placeholder: 'MM/DD/YYYY' };
//# sourceMappingURL=index.js.map